// FICHIER GÉNÉRÉ — ne pas modifier à la main (voir scripts/lucide-shim.js).
// Import de namespace : aucune vérification d'export nommé par webpack, donc
// aucun échec de compilation possible même si la librairie renomme ses icônes.
import * as L from 'lucide-react';

// Icône neutre de repli : garantit que l'interface ne casse jamais.
const Repli = (props) => (
  <svg viewBox="0 0 24 24" width={props.size ?? 16} height={props.size ?? 16} fill="none" stroke="currentColor" strokeWidth="2" {...props}>
    <circle cx="12" cy="12" r="9" />
  </svg>
);

const choisir = (...noms) => noms.map((n) => L[n]).find(Boolean) ?? Repli;

export const AlertTriangle = choisir('AlertTriangle', 'AlertTriangleIcon', 'LucideAlertTriangle');
export const ArrowLeft = choisir('ArrowLeft', 'ArrowLeftIcon', 'LucideArrowLeft');
export const ArrowLeftRight = choisir('ArrowLeftRight', 'ArrowLeftRightIcon', 'LucideArrowLeftRight');
export const ArrowRight = choisir('ArrowRight', 'ArrowRightIcon', 'LucideArrowRight');
export const ArrowRightLeft = choisir('ArrowRightLeft', 'ArrowRightLeftIcon', 'LucideArrowRightLeft');
export const Coins = choisir('Coins', 'CoinsIcon', 'LucideCoins');
export const HandCoins = choisir('HandCoins', 'HandCoinsIcon', 'LucideHandCoins');
export const Banknote = choisir('Banknote', 'BanknoteIcon', 'LucideBanknote');
export const BookOpen = choisir('BookOpen', 'BookOpenIcon', 'LucideBookOpen');
export const Bot = choisir('Bot', 'BotIcon', 'LucideBot');
export const Boxes = choisir('Boxes', 'BoxesIcon', 'LucideBoxes');
export const Building2 = choisir('Building2', 'Building2Icon', 'LucideBuilding2');
export const Calculator = choisir('Calculator', 'CalculatorIcon', 'LucideCalculator');
export const CalendarRange = choisir('CalendarRange', 'CalendarRangeIcon', 'LucideCalendarRange');
export const Camera = choisir('Camera', 'CameraIcon', 'LucideCamera');
export const Check = choisir('Check', 'CheckIcon', 'LucideCheck');
export const Scissors = choisir('Scissors', 'ScissorsIcon', 'LucideScissors');
export const CloudUpload = choisir('CloudUpload', 'CloudUploadIcon', 'LucideCloudUpload', 'UploadCloud');
export const ExternalLink = choisir('ExternalLink', 'ExternalLinkIcon', 'LucideExternalLink');
export const Archive = choisir('Archive', 'ArchiveIcon', 'LucideArchive');
export const Gavel = choisir('Gavel', 'GavelIcon', 'LucideGavel', 'Scale');


export const CheckCircle2 = choisir('CheckCircle2', 'CheckCircle2Icon', 'LucideCheckCircle2');
export const CheckSquare = choisir('CheckSquare', 'CheckSquareIcon', 'LucideCheckSquare');
export const ChevronDown = choisir('ChevronDown', 'ChevronDownIcon', 'LucideChevronDown');
export const ChevronLeft = choisir('ChevronLeft', 'ChevronLeftIcon', 'LucideChevronLeft');
export const ChevronRight = choisir('ChevronRight', 'ChevronRightIcon', 'LucideChevronRight');
export const ChevronUp = choisir('ChevronUp', 'ChevronUpIcon', 'LucideChevronUp');
export const Circle = choisir('Circle', 'CircleIcon', 'LucideCircle');
export const ClipboardCheck = choisir('ClipboardCheck', 'ClipboardCheckIcon', 'LucideClipboardCheck');
export const ClipboardList = choisir('ClipboardList', 'ClipboardListIcon', 'LucideClipboardList');
export const Clock = choisir('Clock', 'ClockIcon', 'LucideClock');
export const Cloud = choisir('Cloud', 'CloudIcon', 'LucideCloud');
export const CloudOff = choisir('CloudOff', 'CloudOffIcon', 'LucideCloudOff');
export const Copy = choisir('Copy', 'CopyIcon', 'LucideCopy');
export const DatabaseBackup = choisir('DatabaseBackup', 'DatabaseBackupIcon', 'LucideDatabaseBackup');
export const Delete = choisir('Delete', 'DeleteIcon', 'LucideDelete');
export const Eraser = choisir('Eraser', 'EraserIcon', 'LucideEraser');
export const Download = choisir('Download', 'DownloadIcon', 'LucideDownload');
export const Droplet = choisir('Droplet', 'DropletIcon', 'LucideDroplet');
export const Droplets = choisir('Droplets', 'DropletsIcon', 'LucideDroplets');
export const Factory = choisir('Factory', 'FactoryIcon', 'LucideFactory');
export const FilePlus2 = choisir('FilePlus2', 'FilePlus2Icon', 'LucideFilePlus2');
export const FileSpreadsheet = choisir('FileSpreadsheet', 'FileSpreadsheetIcon', 'LucideFileSpreadsheet');
export const FileStack = choisir('FileStack', 'FileStackIcon', 'LucideFileStack');
export const FileText = choisir('FileText', 'FileTextIcon', 'LucideFileText');
export const GripVertical = choisir('GripVertical', 'GripVerticalIcon', 'LucideGripVertical');
export const History = choisir('History', 'HistoryIcon', 'LucideHistory');
export const Inbox = choisir('Inbox', 'InboxIcon', 'LucideInbox');
export const Info = choisir('Info', 'InfoIcon', 'LucideInfo');
export const BarChart3 = choisir('BarChart3', 'BarChart3Icon', 'LucideBarChart3');

export const Landmark = choisir('Landmark', 'LandmarkIcon', 'LucideLandmark');
export const LayoutDashboard = choisir('LayoutDashboard', 'LayoutDashboardIcon', 'LucideLayoutDashboard');
export const Leaf = choisir('Leaf', 'LeafIcon', 'LucideLeaf');
export const Link2Off = choisir('Link2Off', 'Link2OffIcon', 'LucideLink2Off');
export const Loader2 = choisir('Loader2', 'Loader2Icon', 'LucideLoader2');
export const Lock = choisir('Lock', 'LockIcon', 'LucideLock');
export const LogOut = choisir('LogOut', 'LogOutIcon', 'LucideLogOut');
export const Maximize = choisir('Maximize', 'MaximizeIcon', 'LucideMaximize');
export const Menu = choisir('Menu', 'MenuIcon', 'LucideMenu');
export const MessageCircle = choisir('MessageCircle', 'MessageCircleIcon', 'LucideMessageCircle');
export const MessageSquare = choisir('MessageSquare', 'MessageSquareIcon', 'LucideMessageSquare');
export const Minus = choisir('Minus', 'MinusIcon', 'LucideMinus');
export const MoreHorizontal = choisir('MoreHorizontal', 'MoreHorizontalIcon', 'LucideMoreHorizontal');
export const Package = choisir('Package', 'PackageIcon', 'LucidePackage');
export const PackageMinus = choisir('PackageMinus', 'PackageMinusIcon', 'LucidePackageMinus');
export const PackagePlus = choisir('PackagePlus', 'PackagePlusIcon', 'LucidePackagePlus');
export const Pencil = choisir('Pencil', 'PencilIcon', 'LucidePencil');
export const Play = choisir('Play', 'PlayIcon', 'LucidePlay');
export const Plus = choisir('Plus', 'PlusIcon', 'LucidePlus');
export const Power = choisir('Power', 'PowerIcon', 'LucidePower');
export const Printer = choisir('Printer', 'PrinterIcon', 'LucidePrinter');
export const QrCode = choisir('QrCode', 'QrCodeIcon', 'LucideQrCode');
export const Radio = choisir('Radio', 'RadioIcon', 'LucideRadio');
export const Receipt = choisir('Receipt', 'ReceiptIcon', 'LucideReceipt');
export const Recycle = choisir('Recycle', 'RecycleIcon', 'LucideRecycle');
export const RefreshCw = choisir('RefreshCw', 'RefreshCwIcon', 'LucideRefreshCw');
export const RotateCcw = choisir('RotateCcw', 'RotateCcwIcon', 'LucideRotateCcw');
export const Save = choisir('Save', 'SaveIcon', 'LucideSave');
export const Scale = choisir('Scale', 'ScaleIcon', 'LucideScale');
export const Search = choisir('Search', 'SearchIcon', 'LucideSearch');
export const Send = choisir('Send', 'SendIcon', 'LucideSend');
export const ShieldAlert = choisir('ShieldAlert', 'ShieldAlertIcon', 'LucideShieldAlert');
export const ShieldCheck = choisir('ShieldCheck', 'ShieldCheckIcon', 'LucideShieldCheck');
export const Smartphone = choisir('Smartphone', 'SmartphoneIcon', 'LucideSmartphone');
export const Sparkles = choisir('Sparkles', 'SparklesIcon', 'LucideSparkles');
export const Square = choisir('Square', 'SquareIcon', 'LucideSquare');
export const Trash2 = choisir('Trash2', 'Trash2Icon', 'LucideTrash2');
export const TrendingDown = choisir('TrendingDown', 'TrendingDownIcon', 'LucideTrendingDown');
export const TrendingUp = choisir('TrendingUp', 'TrendingUpIcon', 'LucideTrendingUp');
export const Truck = choisir('Truck', 'TruckIcon', 'LucideTruck');
export const Upload = choisir('Upload', 'UploadIcon', 'LucideUpload');
export const UploadCloud = choisir('UploadCloud', 'UploadCloudIcon', 'LucideUploadCloud');
export const User = choisir('User', 'UserIcon', 'LucideUser');
export const UserPlus = choisir('UserPlus', 'UserPlusIcon', 'LucideUserPlus');
export const Users = choisir('Users', 'UsersIcon', 'LucideUsers');
export const Unlock = choisir('Unlock', 'UnlockIcon', 'LucideUnlock', 'LockOpen');
export const Wallet = choisir('Wallet', 'WalletIcon', 'LucideWallet');
export const X = choisir('X', 'XIcon', 'LucideX');
export const XCircle = choisir('XCircle', 'XCircleIcon', 'LucideXCircle');
export const Zap = choisir("Zap", "ZapIcon", "LucideZap");
